import { render } from "./PageFormKetentuanUmum.vue?vue&type=template&id=166085c4"
import script from "./PageFormKetentuanUmum.vue?vue&type=script&lang=js"
export * from "./PageFormKetentuanUmum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__